// The two states the Business Unit dialog can be in. They differ in exactly one thing:
// whether there is a branch to fall back to, which decides whether the way out of the
// dialog is Cancel or Logout.
//
// Their own module so BizContext and Body can both read them without importing each
// other — BizContext renders Body, so a constant living in BizContext would make that
// a cycle.
export const REQUIRED = "required"; // nothing chosen yet — the only way out is Logout
export const SWITCH = "switch";     // a branch is already in force — Cancel returns to it
